module.exports = __webpack_public_path__ + "img/HQ-OA-360V05NU_ALL.880e27f7.jpg";